

// import {
//   FETCH_PARK_USERS_REQUEST,
//   FETCH_PARK_USERS_SUCCESS,
//   FETCH_PARK_USERS_FAILURE,
//   UPDATE_PARK_USER_REQUEST,
//   UPDATE_PARK_USER_SUCCESS,
//   UPDATE_PARK_USER_FAILURE,
//   UPDATE_PARK_USER_STATUS_REQUEST,
//   UPDATE_PARK_USER_STATUS_SUCCESS,
//   UPDATE_PARK_USER_STATUS_FAILURE,
// } from "../actions/parkEmployeeActions";

// const initialState = {
//   parkUsers: [],
//   loading: false,
//   error: null,
//   page: 1,
//   limit: 10,
//   total: 0,
//   totalPages: 1,
//   district: "",
//   municipality: "",
//   searchTerm: "",
//   sortField: "",
//   sortOrder: "asc",
//   project_type: "",
// };

// export default function parkEmployeeReducer(state = initialState, action) {
//   switch (action.type) {
//     case FETCH_PARK_USERS_REQUEST:
//     case UPDATE_PARK_USER_REQUEST:
//     case UPDATE_PARK_USER_STATUS_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_PARK_USERS_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         parkUsers: action.payload.users,
//         page: action.payload.meta.page,
//         limit: action.payload.meta.limit,
//         total: action.payload.meta.total,
//         totalPages: action.payload.meta.totalPages,
//         // save filters and sort info in state
//         district: action.payload.meta.district || "",
//         municipality: action.payload.meta.municipality || "",
//         searchTerm: action.payload.meta.search || "",
//         sortField: action.payload.meta.sortField || "",
//         sortOrder: action.payload.meta.sortOrder || "asc",
//          project_type: action.payload.meta.project_type || "", // ✅ added
//       };

//     case UPDATE_PARK_USER_SUCCESS:
//       return { ...state, loading: false };

//     case UPDATE_PARK_USER_STATUS_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         parkUsers: state.parkUsers.map((user) =>
//           user.id === action.payload.userId
//             ? { ...user, status: action.payload.status }
//             : user
//         ),
//       };

//     case FETCH_PARK_USERS_FAILURE:
//     case UPDATE_PARK_USER_FAILURE:
//     case UPDATE_PARK_USER_STATUS_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// }


import {
  FETCH_PARK_USERS_REQUEST,
  FETCH_PARK_USERS_SUCCESS,
  FETCH_PARK_USERS_FAILURE,
  UPDATE_PARK_USER_REQUEST,
  UPDATE_PARK_USER_SUCCESS,
  UPDATE_PARK_USER_FAILURE,
  UPDATE_PARK_USER_STATUS_REQUEST,
  UPDATE_PARK_USER_STATUS_SUCCESS,
  UPDATE_PARK_USER_STATUS_FAILURE,
} from "../actions/parkEmployeeActions";

const initialState = {
  parkUsers: [],
  loading: false,
  error: null,
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 1,
  district: "",
  municipality: "",
  searchTerm: "",
  sortField: "",
  sortOrder: "asc",
  project_type: "",
};

export default function parkEmployeeReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PARK_USERS_REQUEST:
    case UPDATE_PARK_USER_REQUEST:
    case UPDATE_PARK_USER_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PARK_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        parkUsers: action.payload.users,
        page: action.payload.meta.page,
        limit: action.payload.meta.limit,
        total: action.payload.meta.total,
        totalPages: action.payload.meta.totalPages,
        district: action.payload.meta.district || "",
        municipality: action.payload.meta.municipality || "",
        searchTerm: action.payload.meta.search || "",
        sortField: action.payload.meta.sortField || "",
        sortOrder: action.payload.meta.sortOrder || "asc",
        project_type: action.payload.meta.project_type || "",
      };

    case UPDATE_PARK_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        // Update the specific user in the parkUsers array
        parkUsers: state.parkUsers.map((user) =>
          user.id === action.payload.userId
            ? { ...user, ...action.payload.updatedUser } // Merge updated fields
            : user
        ),
      };

    case UPDATE_PARK_USER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        parkUsers: state.parkUsers.map((user) =>
          user.id === action.payload.userId
            ? { ...user, status: action.payload.status }
            : user
        ),
      };

    case FETCH_PARK_USERS_FAILURE:
    case UPDATE_PARK_USER_FAILURE:
    case UPDATE_PARK_USER_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}